// マルチビューアのパス
export const MULTI_VIEWER_PATH = '/viewer/multi';
